import { gql } from '@apollo/client'

export default gql`
  fragment LibraryPostArticleCardComponent on LibraryPostArticle {
    slug
    type
    title
    image {
      url
      blurhash
    }
    description
  }
`
